import React, { useState, useEffect } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { SearchContext } from "./Contexts/Context";
import { useContext } from "react";

import { FaFacebookF, FaTwitter } from "react-icons/fa";
import moment from "moment";
import "moment/locale/ka";
import Gallery from "../helpers/gallery";
import pdf from "../images/collection-pdf.png";
import FacebookShareButton from "./FacebookShareButton";

function News() {
  const currentUrl = window.location.href;

  const { id } = useParams();

  console.log("id", id);

  // const [news, setNews] = useState(ArrayOfObject[id])
  const [moreNews, setMoreNews] = useState({});

  //  const [news,setNews] = useState({})
  const [exactNews, setExactNews] = useState({});
  const { language } = useContext(SearchContext);

  const [newsId, setNewsId] = useState({});
  // Lumos Fc
  useEffect(() => {
    fetch("https://khulo.lumos.com.ge/news/" + id)
      .then((response) => response.json())
      .then((data) => {
        setNewsId(data);
      });
  }, []);

  //More news lumos
  const [allNews, setAllNews] = useState({});

  console.log("allNews" + allNews?.results);
  useEffect(() => {
    fetch("https://khulo.lumos.com.ge/news/?category=სიახლეები")
      .then((response) => response.json())
      .then((data) => {
        setAllNews(data);
      });
  }, []);
  const AssemblyNews = () => {
    moment.locale("ka");
    return (
      <>
        {allNews?.results
          ?.reverse()
          .filter((item) => item.slug !== id)
          .slice(0, 2)
          .map((item) => (
            <Link to={`/news/${item.slug}`} key={item.id}>
              <div className="landing-items-container-infos" id={item.id}>
                <div className="new-image-wrapper">
                  <img src={item.img} alt="" />
                </div>
                <div>
                  <span className="time">
                    {moment(item.created_at).format("LL")}{" "}
                  </span>
                  <span className="header">{item.title}</span>
                  <span className="vrclad">
                    <Link to={`/sakrebulos-siakhleebi/${item.slug}`}>
                      {" ვრცლად"}
                    </Link>
                  </span>
                </div>
              </div>
            </Link>
          ))}
      </>
    );
  };
  // useEffect(() => {
  // 	const link = 'https://khulo.gov.ge/api/news.php?lang=geo';
  // 	fetch(link)
  // 		.then(response => response.json())
  // 		.then(data => {
  // 			data['საკრებულოს სიახლეები'][id] &&
  // 				setExactNews(data['საკრებულოს სიახლეები'][id]);
  // 			data['საკრებულოს სიახლეები'] &&
  // 				setMoreNews(data['საკრებულოს სიახლეები']);
  // 			// console.log('data ID',data.სიახლეები[id].geo)

  // 			// console.log(data.სიახლეები[id].geo.text)

  // 			// console.log(data)
  // 			// console.log('news', news)

  // 			// console.log('object keys menu', Object.keys(menu))
  // 			// console.log('object entries news', Object.entries(data))
  // 		});
  // 	// console.log('news', news)
  // 	// console.log('news 0', news[0])
  // }, []);

  const newsList = Object.entries(moreNews).length
    ? Object.entries(moreNews)
        .reverse()
        .filter((news) => id !== news[0])
        .map((news, i) => {
          if (i <= 1) {
            return (
              <Link to={`/news/${news[0]}`}>
                <div
                  className="landing-items-container-infos"
                  id={news.id}
                  key={news.id}
                >
                  <div className="new-image-wrapper">
                    <img
                      src={
                        "https://khulo.gov.ge/" +
                        (news[1].geo.thumb_img
                          ? news[1].geo.thumb_img
                          : news[1].geo.img)
                      }
                      alt=""
                    />
                  </div>
                  <div>
                    <span className="time">
                      {language == 1 ? news[1].geo.date : ""}
                      {language == 2 ? news[1].eng.date : ""}
                    </span>
                    <span className="header">
                      {language == 1 ? news[1].geo.title : ""}
                      {language == 2 ? news[1].eng.title : ""}
                    </span>
                    <span className="vrclad">
                      <Link to={`/news/${news[0]}`}>
                        {language == 1 ? " ვრცლად" : ""}
                        {language == 2 ? " See more" : ""}
                      </Link>
                    </span>
                  </div>
                </div>
              </Link>
            );
          }
        })
    : "loading news";

  return (
    <div className="news1-container margin-280px">
      <header>
        <span className="big">
          {" "}
          {"პრესცენტრი"}
          {/* {language == 2 ? ' KHULO CITY ASSEMBLY' : ''} */}
        </span>
        <span>
          {language == 1 ? "  სიახლეები" : ""}
          {language == 2 ? " NEWS" : ""}
        </span>
      </header>
      <div className="main">
        <div className="sakrebulo-page">
          <div className="main-picture">
            <img src={newsId.img} alt="" />
            <span className="time">
              {" "}
              {moment(newsId.created_at).format("LL")}
            </span>
            <span className="header">{newsId.title}</span>
          </div>
          <div className="main-content">
            {
              <span
                className="main-content-text"
                dangerouslySetInnerHTML={{
                  __html: newsId.description
                    ? newsId.description
                        .replaceAll("<img", '<img tabIndex="-1"')
                        .replaceAll(
                          "../uploads",
                          "https://www.khulo.gov.ge/uploads",
                        )
                    : "",
                }}
              ></span>
            }
            <div className="pdf-file" style={{ marginBottom: "90px" }}>
              {" "}
              {newsId.file ? (
                <div
                  className="sakrebulo-landing"
                  style={{
                    backgroundColor: "red !important",

                    height: "50px",
                  }}
                >
                  <div className="landing-container">
                    <div className="sajaroInfo">
                      <div className="">
                        <a href={newsId.file} target="blank">
                          <span>{newsId.file_name}</span>

                          <img src={pdf} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {/* <div
							style={{ borderTop: '1px solid #ccc', margin: '20px 0' }}
						></div> */}
            <div className="pdf-file" style={{ marginBottom: "90px" }}>
              {" "}
              {newsId.file_upload ? (
                <div
                  className="sakrebulo-landing"
                  style={{
                    backgroundColor: "red !important",

                    height: "50px",
                  }}
                >
                  <div className="landing-container">
                    <div className="sajaroInfo">
                      {newsId.file_upload.map((file, index) => (
                        <div className="" key={file.id}>
                          <a href={file.file} target="blank">
                            <span>{file.title}</span>
                            <img src={pdf} alt="" />
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <span>
              {" "}
              {language == 1 ? "   გააზიარე:" : ""}
              {language == 2 ? "SHARE:" : ""}
              <FacebookShareButton
                title={newsId.title}
                description={newsId.description}
                image={newsId.img}
                newsId={currentUrl}
              />
            </span>
            <div
              className="gallery"
              style={{ borderTop: "10px solid #f6f8f9", paddingTop: "20px" }}
            >
              {newsId.additional_images ? (
                <>
                  <p
                    style={{
                      marginLeft: "20px",
                      marginBottom: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    გალერეა
                  </p>
                  <Gallery img={newsId.additional_images} />
                </>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
        <div className="moreNews">
          <span>
            {" "}
            {language == 1 ? "   სხვა სიახლეები:" : ""}
            {language == 2 ? "OTHER NEWS:" : ""}
          </span>
          <AssemblyNews />
        </div>
      </div>
    </div>
  );
}

export default News;
